import { render, staticRenderFns } from "./FoodSearch.vue?vue&type=template&id=79b1172f&scoped=true&"
import script from "./FoodSearch.vue?vue&type=script&lang=js&"
export * from "./FoodSearch.vue?vue&type=script&lang=js&"
import style0 from "./FoodSearch.vue?vue&type=style&index=0&id=79b1172f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b1172f",
  null
  
)

export default component.exports